import { inject, Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpStatusCode,
} from '@angular/common/http';

import { catchError, fromEvent, Observable, ObservableInput, retry, take, throwError, timeout } from 'rxjs';

import { WindowRef } from '../providers';
import { MonitoringLogger } from '../services';

const CHALLENGE_TIMEOUT_IN_MS = 30000;
export const CRYPTO_CHALLENGE_EVENT_NAME = 'akamai-challenge-noreload';

@Injectable()
export class CryptoChallengeInterceptor implements HttpInterceptor {
  private windowRef = inject(WindowRef);
  private monitoringLogger = inject(MonitoringLogger);

  public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      retry({
        count: 1,
        delay: (error: HttpErrorResponse): ObservableInput<Event> => {
          if (error.status !== HttpStatusCode.PreconditionRequired) {
            return throwError(() => error);
          }

          return fromEvent(this.windowRef.nativeWindow.document, CRYPTO_CHALLENGE_EVENT_NAME).pipe(
            take(1),
            timeout(CHALLENGE_TIMEOUT_IN_MS),
            catchError((err: unknown) => {
              this.monitoringLogger.error('Error while waiting for the Akamai challenge completion event', {
                error: err,
                originalError: error,
              });
              return throwError(() => error); // Re-throw the original 428 error
            })
          );
        },
      })
    );
  }
}
